import React from 'react';
import {Card} from '@albert-io/atomic';
import {useShallow} from 'zustand/react/shallow';
import {useQuestionStore} from 'client/components/QuestionTypes/V2/useQuestionStores';
import {QuestionModelV3} from '@albert-io/models';
import Divider from './Divider.react';
import {Item} from './Item.react';
import useQuestionAndDrafts from '../../V2/useQuestionAndDrafts.hook';
import classNames from 'classnames';
interface Props {
  question: QuestionModelV3;
}
export const ItemList = ({question}: Props) => {
  const useStoreHook = useQuestionStore<'ordering'>(question);

  const {saveDraftGuess} = useQuestionAndDrafts(question);

  const {
    activeItemId,
    items,
    isDragging,
    hoveredDividerId,
    setActiveItemId,
    moveItemToPosition,
    isSubmitted
  } = useStoreHook(
    useShallow((state) => ({
      items: state.items,
      activeItemId: state.activeItemId,
      isDragging: state.isDragging,
      hoveredDividerId: state.hoveredDividerId,
      setActiveItemId: state.setActiveItem,
      setHoveredDividerId: state.setHoveredDividerId,
      moveItemToPosition: state.moveItemToPosition,
      isSubmitted: state.isSubmitted
    }))
  );

  const handleItemClick = (itemId: string, _e?: React.MouseEvent) => {
    if (isDragging) return;

    if (activeItemId === itemId) {
      setActiveItemId(null);
    } else {
      setActiveItemId(itemId);
    }
  };

  const handleDividerClick = (dividerIndex: number) => {
    if (isDragging || !activeItemId) return;

    moveItemToPosition(activeItemId, dividerIndex);
    saveDraftGuess();
    setActiveItemId(null);
  };

  return (
    <Card
      paddingLevel={2}
      className={classNames('flex flex-wrap items-center', {
        'gap-x3 pl-x3': isSubmitted,
        'pl-x0': !isSubmitted
      })}
    >
      {/* Leading divider */}
      {!isSubmitted && (
        <Divider
          id='divider-0'
          isVisible={isDragging || activeItemId !== null}
          isHovered={hoveredDividerId === 'divider-0'}
          onClick={() => handleDividerClick(0)}
        />
      )}
      {items.map((item, index) => (
        <Item
          key={item.id}
          item={item}
          index={index}
          handleItemClick={handleItemClick}
          handleDividerClick={handleDividerClick}
          question={question}
        />
      ))}
    </Card>
  );
};

export default ItemList;
